import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PersonalData from "./PersonalData/PersonalData";
import TokenHistory from "./TokenHistory/TokenHistory";
import RequestHistory from "./RequestHistory/RequestHistory";
import ServiceHistory from "./ServiceHistory/ServiceHistory";
import Support from "./Support/Support";
import GroupsCustomer from "./GroupsCustomer/GroupsCustomer";
import "./InfoCustomer.css";
//permissions
import { modulePermissions } from "../../../../utils/modulePermissions";

const InfoCustomer = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("personal");
  const [tabs, setTabs] = useState([]);
  const [customerData, setCustomerData] = useState({
    id: "",
    name: "",
    email: "",
    qualification: "",
    telephone: "",
    dateOfBirth: "",
    gender: "",
    status: "",
    location: "",
    dateOfRegistration: "",
    paymentMethods: "",
    addresses: "",
    services: "",
    profile: {
      customer_rating: "",
      supplier_rating: "",
      biography: "",
      gender: "",
      birthdate: "",
    },
    paymentMethods: []
  });

  useEffect(() => {
    console.log(location.state);
    if (location.state?.customer) {
      const data = location.state.customer;
      setCustomerData({
        id: data.id,
        name: data.name,
        email: data.email,
        qualification: data.qualification,
        telephone: data.telephone,
        dateOfBirth: data.profile?.birthdate,
        gender: data.profile?.gender,
        status: data.status,
        location: data.location,
        dateOfRegistration: data.created_at,
        profile: {
          customer_rating: data.profile?.customer_rating,
          supplier_rating: data.profile?.supplier_rating,
          biography: data.profile?.biography,
          gender: data.profile?.gender,
          birthdate: data.profile?.birthdate,
        },
        paymentMethods: data.payment_methods
      });
      fetchTabs();
    }
  }, [location]);

  const fetchTabs = () => {
    let currentTabs = [];
    if (modulePermissions.hasClientPersonalDataPermission("view")) {
      currentTabs.push({ id: "personal", label: "Personal Data" });
    }
    if (modulePermissions.hasClientTokenHistoryPermission("view")) {
      currentTabs.push({ id: "token", label: "Barter Bucks History" });
    }
    if (modulePermissions.hasClientRequestHistoryPermission("view")) {
      currentTabs.push({ id: "request", label: "Request History" });
    }
    if (modulePermissions.hasClientReceivedServiceHistoryPermission("view")) {
      currentTabs.push({
        id: "services",
        label: "History of Services Received",
      });
    }
    currentTabs.push({
      id: "services-offered",
      label: "History of Services Offered",
    });
    if (modulePermissions.hasClientSupportPermission("view")) {
      currentTabs.push({ id: "support", label: "Support" });
    }
    if (modulePermissions.hasClientGroupsPermission("view")) {
      currentTabs.push({ id: "groups", label: "Groups" });
    }
    if (currentTabs.length === 0) {
      setActiveTab("");
    } else {
      const tabActive = currentTabs[0].id;
      setActiveTab(tabActive);
    }
    setTabs(currentTabs);
  };

  return (
    <div className="info-customer-page">
      <div className="info-customer-container">
        <div className="info-tabs">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`tab-item ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </div>
          ))}
        </div>

        {activeTab === "personal" && (
          <PersonalData customerData={customerData} />
        )}

        {activeTab === "token" && <TokenHistory id={customerData.id} />}

        {activeTab === "request" && <RequestHistory id={customerData.id} />}

        {activeTab === "services" && (
          <ServiceHistory
            id={customerData.id}
            type="received"
            supplier={customerData.name}
          />
        )}

        {activeTab === "services-offered" && (
          <ServiceHistory
            id={customerData.id}
            type="offered"
            supplier={customerData.name}
          />
        )}

        {activeTab === "support" && <Support user_id={customerData.id} />}

        {activeTab === "groups" && <GroupsCustomer user_id={customerData.id} />}
      </div>
    </div>
  );
};

export default InfoCustomer;
